import { useCallback, useEffect } from 'react';
import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { RowGroup, useTable } from '../../../hooks/table';
export function useRowGroup(options) {
  var table = useTable();
  var group = useSingleton(function () {
    return new RowGroup(table);
  });
  var onExpandedRowChange = useRefCallback(options.onExpandedRowChange);
  group.updateRowGroup(options);
  var onExpand = useCallback(function (id, expanded) {
    return group.setRowExpand(id, expanded);
  }, []);
  useEffect(function () {
    group.addListener('expanded-change', onExpandedRowChange);
    return function () {
      return group.removeListener('expanded-change', onExpandedRowChange);
    };
  }, []);
  return {
    rowKey: table.getRowKey(),
    rows: group.getRenderRows(),
    onExpand: onExpand
  };
}